import React from 'react'
import { FrecuencyNotificationId, ScheduleFrecuency } from '../../ScheduleNotification/CreateScheduleNotification/CreateScheduleNotificationForm/CreateScheduleNotificationForm'
import { Schedule } from '../../../redux/slices/components/ScheduleNotifications/scheduleNotificationsSlice'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

export const getScheduleFrecuency = (frecuencyId: FrecuencyNotificationId, schedule: Schedule): ScheduleFrecuency => {
    if(frecuencyId === "One_time"){
        const d = moment().date(Number(schedule.dayOfMonth)).month(Number(schedule.month) - 1).year(Number(schedule.year)).startOf("day").utc()
        const h = moment().utc().date(Number(schedule.dayOfMonth)).hour(schedule.hour).minutes(schedule.minutes)

        return {
            id: "One_time",
            utcDate: d.toISOString(),
            utcHour: h?.toISOString()
        }
    }else if(frecuencyId === "Every_day"){
        const h = moment().utc().hour(schedule.hour).minutes(schedule.minutes)
        return {
            id: "Every_day",
            utcHour: h?.toISOString()
        }
    }else if(frecuencyId === "Every_week"){
        const h = moment().utc().hour(schedule.hour).minutes(schedule.minutes)
        return {
            id: "Every_week",
            utcHour: h?.toISOString(),
            weekDay: schedule.dayOfWeek
        }
    }else{
        const d = moment().date(Number(schedule.dayOfMonth)).startOf("day").utc()
        const h = moment().utc().date(Number(schedule.dayOfMonth)).hour(schedule.hour).minutes(schedule.minutes)
        return {
            id: "Every_month",
            utcDate: d.toISOString(),
            utcHour: h?.toISOString()
        }
    }
}

type useGetScheduleTextProps = {
    type: "Schedule"
    frecuencyId: FrecuencyNotificationId
    schedule: Schedule
} | {
    type: "ScheduleFrecuency"
    frecuencyId: FrecuencyNotificationId
    schedule: ScheduleFrecuency
} | {
    type: "NOT_SCHEDULE"
}

const useGetScheduleText = (props: useGetScheduleTextProps) => {

    const { t } = useTranslation()
    console.log("props", props)
    if(props.type === "NOT_SCHEDULE"){
        return {
            textDate: "",
            alreadyExecutedOneTime: false,
            hourText: "",
            textHourDate: ``,
            notSchedule: true
        }
    }

    let resumeDate = ""
    let schedule: ScheduleFrecuency = {} as ScheduleFrecuency
    let alreadyExecutedOneTime = false

    if(props.type === "Schedule"){
        schedule = getScheduleFrecuency(props.frecuencyId, props.schedule)
    }else{
        schedule = props.schedule
    }

    if(schedule.id === "One_time"){
        resumeDate = `${moment(schedule.utcDate).date()} ${t("Notifications:schedule:index:label_11")} ${moment(schedule.utcDate).format("MMMM")} ${t("Notifications:schedule:index:label_11")} ${moment(schedule.utcDate).format("YYYY")}`
        
        const scheduledDate = moment.utc(schedule.utcDate)
            .local()
            .hour(moment(schedule.utcHour).hour())
            .minute(moment(schedule.utcHour).minute())
            .second(0)
            .millisecond(0);
        const now = moment.utc();
        /*
        console.log(" ")
        console.log("11111", schedule.utcDate)
        console.log("22222", moment(schedule.utcHour).hour())
        console.log("33333", moment.utc(schedule.utcDate).toISOString())
        console.log("44444", moment.utc(schedule.utcDate).hour(moment(schedule.utcHour).hour()).toISOString())
        console.log("55555", moment.utc(schedule.utcDate).local().hour(moment(schedule.utcHour).hour()).toISOString())
        console.log("now", now.toISOString())
        console.log("scheduledDate", scheduledDate.toISOString())
        console.log("------", now.isAfter(scheduledDate))
        */
        alreadyExecutedOneTime = now.isAfter(scheduledDate);

    }else if(schedule.id === "Every_day"){
        resumeDate = t("Notifications:schedule:index:label_12")
    }else if(schedule.id === "Every_week"){
        resumeDate = `${t("Notifications:schedule:index:label_13")} ${t(`Notifications:schedule:${schedule.weekDay}`)}`
    }else if(schedule.id === "Every_month"){
        resumeDate = `${t("Notifications:schedule:index:label_14")} ${moment(schedule.utcDate).date()} ${t("Notifications:schedule:index:label_15")}`
    }

    const hourText = `${t("Notifications:schedule:index:label_30")} ${moment(schedule.utcHour).format("hh:mm a")} ${t("Notifications:schedule:index:label_31")}`

    return {
        textDate: resumeDate,
        alreadyExecutedOneTime,
        hourText,
        textHourDate: `${resumeDate} ${hourText}`,
        notSchedule: false
    }
}

export default useGetScheduleText